import request from '@/utils/request'
import { getToken } from '../utils/auth'
// 查询所有未接单
export function queryalarmbysoid (data) {
  return request({
    url: '/queryalarmbysoid',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 服务商查询人员
export function querypersonbysoidanddid (data) {
  return request({
    url: '/querypersonbysoidanddid',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 处理接单
export function handlecasebyso (data) {
  return request({
    url: '/handlecasebyso',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 获取老人服务单
export function querysupplierservicerecords (params, data) {
  params.token = getToken()
  return request({
    url: '/querysupplierservicerecords',
    method: 'post',
    params,
    data
  })
}

// 处理接单
export function createpersonsupplierservicerecords (data) {
  return request({
    url: '/createpersonsupplierservicerecords',
    method: 'post',
    params: { token: getToken() },
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/companyorder.js